module.exports = __webpack_public_path__ + "img/vertical_3_2_7005.3241d675.png";